
import { Slab } from "@/types/slab";
import { getFullImageUrl } from "@/lib/utils";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";

interface SlabImageViewerProps {
  slab: Slab;
  className?: string;
}

export function SlabImageViewer({ slab, className }: SlabImageViewerProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div 
        className={`aspect-square relative overflow-hidden rounded-lg ${className} cursor-pointer`}
        onClick={() => setIsOpen(true)}
      >
        <img
          src={getFullImageUrl(slab.imageUrl)}
          alt={slab.name}
          className="object-cover w-full h-full"
          onError={(e) => {
            e.currentTarget.src = '/placeholder.svg';
          }}
        />
      </div>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="max-w-[90vw] max-h-[90vh] p-0">
          <DialogHeader className="p-4 absolute top-0 left-0 right-0 z-10 bg-background/80 backdrop-blur-sm">
            <div className="flex items-center justify-between">
              <DialogTitle className="text-xl font-semibold">
                {slab.name}
              </DialogTitle>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => setIsOpen(false)}
                className="h-8 w-8"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          </DialogHeader>
          
          <div className="w-full h-[90vh] flex items-center justify-center p-4">
            <img
              src={getFullImageUrl(slab.imageUrl)}
              alt={slab.name}
              className="max-w-full max-h-full object-contain"
              onError={(e) => {
                e.currentTarget.src = '/placeholder.svg';
              }}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
